module.exports = __webpack_public_path__ + "img/png.45f28323.png";